import type { CartItems } from '../createCartItemsStore';
import { getCartItems } from '../getCartItems';

export const getCartCurrency = (cartItems: CartItems) =>
	getCartItems(cartItems)[0]?.currency || 'USD';
